import { environment as defaultEnvironment } from './environment.defaults';

/**
 * used on test server
 */
export const environment = {
  ...defaultEnvironment,
  apiRoot: 'https://bbo-ext-test.asfinag.at',
  allowedDomain: 'cits-rww-test.asfinag.at',
};
